import { API_REFERENCE } from '../utilities/constant_api';
import { jsonGet } from './ajax';
const $doc = $(document);
const shippingRadio = '.js-shiipingError';
const nextStep = '.js-nextStep';
let nextStepForm = false;
const checkoutShippingMethod = {
  enableNextStep() {
    $(nextStep).attr('disabled', false);
  },

  preventNextStepButton(){
    if(!nextStepForm){
      nextStepForm = true;
      $('#chhShippingMethodUpdateData').submit();
    }
  },
  hideBabyAcademicPopup(){
	  $('#accordiandeliveryMethod').find('.baby-academic-popup').hide();
	  $('#accordiandeliveryMethod').find('.baby-academic-overlay').hide();
  },
  captureUserActionforBabyAcademic(action){
	  let url = `${ACC.config.encodedContextPath}${API_REFERENCE.babyAcademy.optInOrOut}`;
	  url+="?isBabyAcademyOptInOrOut="+action;
	  jsonGet(url)
      .then(data => {
        console.log(data);
      })
      .catch(() => {
        console.log("Error in "+url);
      });
  },
  closePopup(){
	  checkoutShippingMethod.captureUserActionforBabyAcademic("Opt-Out");
	  checkoutShippingMethod.hideBabyAcademicPopup();
  },
  actionBabyAcademySignupBtn(){
	  checkoutShippingMethod.captureUserActionforBabyAcademic("Opt-In");
	  checkoutShippingMethod.hideBabyAcademicPopup();
  },

  init() {
    $doc.on('click', shippingRadio, this.enableNextStep);
    $(document).on('click', '.checkout_shipping_method_nextStep_Btn', this.preventNextStepButton);
    $(document).on('click', '.ba-boxClose', this.closePopup);
    $(document).on('click', '.ba-sign-up-btn', this.actionBabyAcademySignupBtn);
  }
};
checkoutShippingMethod.init();
export default checkoutShippingMethod;
